export const SET_OPEN_TABLE_ROWS = 'collapsibleTable/SET_OPEN_TABLE_ROWS';
export const REMOVE_TABLE = 'collapsibleTable/REMOVE_TABLE';
